import Vue from 'vue'
import sinisterTransformer from '@/transformers/catalog/warehouse/requisitions'

/**
 * @author jorge nuñez lópez <>
 *
 * Fetch requisitions list
 * @return {List}
 */


function paramsTransformer({ status = [], searchQuery }) {
  let finalString = [];

  if (status && status.length) {
    finalString.push(`&status=${status}`);
  } 
  if (searchQuery) {
    finalString.push(`&text=${searchQuery}`);
  }
  return finalString.join("").replace("&", '?');
}

export default (warehouseId, params) => {
  return Vue.$http.get(`iwarehouse/${warehouseId}/requisition/list/${paramsTransformer(params)}`)
    .then(({ data }) => {
      const dataTransformed = sinisterTransformer.fetchCollection(data.iwarehouse_requisitions)
      return dataTransformed
    })
}


// WEBPACK FOOTER //
// ./src/services/purchase/warehouse/fetchRequisitions.js